/**
 * 資料セクション レンダラー — registry を引いて variant の Renderer を表示。
 * プレビューでも公開ページでも使う共通入口。
 */
import type { DocumentSection } from '@goenhub/shared';

import { getVariant } from '../sectionRegistry';

export function DocumentSectionRenderer({ section }: { section: DocumentSection }) {
  const resolved = getVariant(section.type, section.variant);
  if (!resolved?.variant) {
    return (
      <div className="text-xs text-[var(--text-muted)] p-3 border border-dashed border-[var(--border)] rounded">
        未対応のセクション ({section.type} / {section.variant ?? 'default'})
      </div>
    );
  }
  const Renderer = resolved.variant.Renderer;
  return <Renderer config={section.config ?? {}} />;
}
